import { supabase } from '../supabaseClient';

/** Headers for QuickBooks API routes that require the signed-in Supabase user (never send user_id in body). */
export async function quickBooksAuthHeaders() {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) return {};
  return { Authorization: `Bearer ${session.access_token}` };
}
